import { useAtom } from "jotai";

import { interactionModeAtom } from "@design-lab/entities/artwork";
import { BackgroundToggle } from "@design-lab/widgets/artboard/ui/tool-bar/BackgroundToggle";

import type { BackgroundType } from "@design-lab/shared/constants";

import { RefineModeSelector } from "./RefineModeSelector";
import { RefineToolTabs } from "./RefineToolTabs";
import { RefineZoom } from "./RefineZoom";

type RefineDesktopControlsProps = {
  backgroundType: BackgroundType;
  onBackgroundTypeChange: (type: BackgroundType) => void;
  activeTool: string;
  onToolChange: (tool: string) => void;
};

export function RefineDesktopControls({
  backgroundType,
  onBackgroundTypeChange,
  activeTool,
  onToolChange
}: RefineDesktopControlsProps) {
  const [interactionMode, setInteractionMode] = useAtom(interactionModeAtom);

  return (
    <>
      <RefineToolTabs activeTool={activeTool} onToolChange={onToolChange} />

      <div className="pointer-events-auto absolute bottom-16 left-0 right-0 z-10 flex items-center justify-between px-6">
        <BackgroundToggle
          value={backgroundType}
          onValueChange={onBackgroundTypeChange}
          forceFullWidth
        />

        <RefineModeSelector value={interactionMode} onValueChange={setInteractionMode} />

        <RefineZoom maxZoom={10} />
      </div>
    </>
  );
}
